import { openDialog } from 'nike-ui/src/components/dialogs/dialogs';
import KycFormDialog from 'nike-ui/src/components/registration-completion/view/dialog/KycFormDialog';
import UserAnnouncement from '@/menu/views/UserAnnouncement';
import UnverifiedIcon from 'nike-ui/src/icons/svg/unverified-icon-sv.svg';
import i18n from '@i18n';
import { Button } from 'nike-ui/src/components/button/Button';
import React from 'react';

const KycBlockedAnnouncement = () => {
    const handleClick = () => {
        openDialog(KycFormDialog);
    };

    return (
        <UserAnnouncement
            icon={UnverifiedIcon}
            title={i18n('kyc-blocked.announcement.title')}
            description={i18n('kyc-blocked.announcement.description')}
        >
            <Button className="red" primary onClick={handleClick} label={i18n('common.fill.In.button')} />
        </UserAnnouncement>
    );
};

export default KycBlockedAnnouncement;
